export default __webpack_public_path__ + "static/media/480_business03-fr-web.15b370c9.png";